// extracted by mini-css-extract-plugin
export default {"messageContainer":"UserMessage_messageContainer__Smf8K","messageBubble":"UserMessage_messageBubble__dZ5r-"};